import customer_orders from "./customer_orders"
import customer_contracts from "./customer_contracts"
import customer_wallets from "./customer_wallets"
export default {
  customer_orders,
  customer_contracts,
  customer_wallets,
};
